var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ATreeSelect',_vm._g(_vm._b({attrs:{"value":_vm.value,"tree-data-simple-mode":"","dropdown-style":{ maxHeight: '400px', overflow: 'auto' }},on:{"change":v => _vm.$emit('input', v)}},'ATreeSelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }